import { AppThemeConfiguration } from '/@/shared/themes/app-theme-types';

export const defaultDark: AppThemeConfiguration = {
    app: {},
    colors: {
        background: 'rgb(0, 0, 0)',
        'background-alternate': 'rgb(0, 0, 0)',
        black: 'rgb(0, 0, 0)',
        foreground: 'rgb(255, 255, 255)',
        'foreground-muted': 'rgb(200, 200, 200)',
        primary: 'rgb(255, 20, 102)',
        'state-error': 'rgb(255, 0, 0)',
        'state-info': 'rgb(0, 191, 255)',
        'state-success': 'rgb(0, 255, 0)',
        'state-warning': 'rgb(255, 255, 0)',
        surface: 'rgb(20, 20, 20)',
        'surface-foreground': 'rgb(255, 255, 255)',
        white: 'rgb(255, 255, 255)',
    },
    mode: 'dark',
};
